import { autoId } from '@workday/upc-common';
import { DeleteButton, TertiaryButton } from '@workday/canvas-kit-react/button';
import React from 'react';
import { ID_CANCEL_BUTTON, ID_SUBMIT_BUTTON } from '../../../../autoIds';
import './ConfirmDeleteEntry.scss';
import { useGdprDeleteUserMutation } from '../../../../slices/account-api.slice';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteEntryProps {
    onClose: () => void;
}

export function ConfirmDeleteEntry({ onClose }: ConfirmDeleteEntryProps) {
    const [gdprDeleteUser] = useGdprDeleteUserMutation();

    const { t } = useTranslation('account');

    function onSubmit(e) {
        e.preventDefault();
        gdprDeleteUser();
    }

    return (
        <form onSubmit={onSubmit} className='confirmDeleteEntry'>
            <h1>{t('ConfirmDeleteEntry.title')}</h1>
            <h2>{t('ConfirmDeleteEntry.subTitle')}</h2>
            <br />
            <div className='confirmDeleteEntry__footer'>
                <DeleteButton {...autoId(ID_SUBMIT_BUTTON)} type='submit' size='large' grow={true}>
                    {t('ConfirmDeleteEntry.confirmButton')}
                </DeleteButton>
                <br />
                <TertiaryButton
                    className='confirmDeleteEntry__cancel'
                    {...autoId(ID_CANCEL_BUTTON)}
                    type='button'
                    size='large'
                    onClick={onClose}>
                    {t('ConfirmDeleteEntry.cancelButton')}
                </TertiaryButton>
            </div>
        </form>
    );
}
